import { Alert, Button } from '../../shared/ui/components';
import { DOWNLOAD_URL, useAppUpdate } from './appUpdate';

/** Configuración de la app: versión instalada y botón para actualizar cuando hay una nueva. */
export function AppUpdateCard() {
  const u = useAppUpdate();
  return (
    <div className="card" role="region" aria-label="Versión de la app">
      <h2>Versión de la app</h2>
      <p className="small">
        Instalada: <strong>{u.installed ?? '—'}</strong>
        {u.latest ? (
          <>
            {' '}
            · Disponible: <strong>{u.latest}</strong>
          </>
        ) : null}
      </p>
      {u.error ? <Alert>{u.error}</Alert> : null}
      {u.available ? (
        u.automatic ? (
          <>
            <Button busy={u.progress !== null} onClick={() => void u.update()}>
              {u.progress !== null ? `Descargando… ${u.progress}%` : `Actualizar a la versión ${u.latest}`}
            </Button>
            <p className="small muted">Se descarga, se instala y la app se vuelve a abrir sola. El equipo sigue vinculado.</p>
          </>
        ) : (
          <>
            <a className="btn btn--primary" href={DOWNLOAD_URL}>
              <span>Descargar la versión {u.latest}</span>
            </a>
            <p className="small muted">Ábrela al terminar de descargar. Desde esa versión, la app se actualiza con un solo botón.</p>
          </>
        )
      ) : u.installed && u.latest ? (
        <p className="small muted">Tienes la versión más nueva.</p>
      ) : null}
    </div>
  );
}
